export default __webpack_public_path__ + "static/media/house.e8692e70.svg";